import { API_V4 } from "@/services/config/auth-axios";

class ReferralService {
  getInvitation() {
    return API_V4.get("/invitation/invited");
  }
  getInvitedPagination(pageNumber) {
    return API_V4.get(`/invitation/invited?page=${pageNumber}`);
  }
  getInformation() {
    return API_V4.get("/invitation/information");
  }
  getPage() {
    const lang = localStorage.getItem("lang");
    return API_V4.get(`/core/pages/invitation-page/${lang}`);
  }
  getGifts() {
    return API_V4.get("/invitation/rewards");
  }
  getGiftsPagination(pageNumber) {
    return API_V4.get(`/invitation/rewards?page=${pageNumber}`);
  }
}

export default new ReferralService();
